import { render } from "./OverView.vue?vue&type=template&id=4afc33f0&scoped=true"
import script from "./OverView.vue?vue&type=script&lang=js"
export * from "./OverView.vue?vue&type=script&lang=js"

import "./OverView.vue?vue&type=style&index=0&id=4afc33f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afc33f0"]])

export default __exports__